export default __webpack_public_path__ + "static/media/react.fe9be460.PNG";